'use strict';
import util from '../../util';
import crossSellTabs from '../cross_sell_tabs';

// Recommendation carousel initialization 
function recommendationCarousel() {
	if ($('.recommendation-container #recommendation').length > 0) {
		// Tab carousels are initialized per panel by crossSellTabs.
		const recommendationCarousel1 = $('.pdp-page .recommendation-container #recommendation').filter(function () {
			return !$(this).closest('.cross-sell-tab-wrapper').length;
		});
		if (!recommendationCarousel1.length) return;

		var recommendationCarouselItem1 = recommendationCarousel1.find('.recommendation-slide');
		var cartPage = $(".cart_page").length > 0;
		if (recommendationCarouselItem1.length > 1 && cartPage && basketConfirmation !== null & $(window).width() < 415 && $(window).width() > 390) {
			$('#recommendation').css('margin-left','13px');
		}
		$(".loading-cross-sell-carousel").hide();
		if(cartPage) {
			if ($(window).width() >= 1024 && recommendationCarouselItem1.length > 3) {
				recommendationCarousel1.not('.slick-initialized').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 3,
					slidesToScroll: 3,
					nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next" type="button"><span class="next"></span></button></div>',
					prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev" type="button"><span class="prev"></span></button></div>'
				});
			}

			if(!$(recommendationCarousel1).parent('.recommendation-redesign').length) {
				if ($(window).width() > 480 && $(window).width() < 1024 && recommendationCarouselItem1.length > 2) {
					recommendationCarousel1.not('.slick-initialized').slick({
						dots: true,
						infinite: false,
						speed: 300,
						slidesToShow: 2,
						slidesToScroll: 2,
						nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next" type="button"><span class="next"></span></button></div>',
						prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev" type="button"><span class="prev"></span></button></div>'
					});
				}

				if ($(window).width() < 480 && recommendationCarouselItem1.length > 1) {
					recommendationCarousel1.not('.slick-initialized').slick({
					slidesPerRow: 1,
					rows: 2,
					dots: true,
					infinite: false,
					speed: 300,
					nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next" type="button"><span class="next"></span></button></div>',
					prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev" type="button"><span class="prev"></span></button></div>'
				});
				}
			}
		}
		else {
			if ($(window).width() >= 1024 && recommendationCarouselItem1.length > 4) {
				recommendationCarousel1.not('.slick-initialized').slick({
					dots: false,
					infinite: false,
					speed: 300,
					slidesToShow: 5,
					slidesToScroll: 4,
					nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
					prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>'
				});
			}
			if(!$(recommendationCarousel1).parent('.recommendation-redesign').length) {
				if ($(window).width() >= 768 && $(window).width() < 1024 && recommendationCarouselItem1.length > 3) {
					recommendationCarousel1.not('.slick-initialized').slick({
						dots: false,
						infinite: false,
						speed: 300,
						slidesToShow: 3,
						slidesToScroll: 3,
						nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
						prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>'
					});
				}
				if ($(window).width() > 480 && $(window).width() < 768 && recommendationCarouselItem1.length > 2) {
					recommendationCarousel1.not('.slick-initialized').slick({
						dots: true,
						infinite: false,
						speed: 300,
						slidesToShow: 2,
						slidesToScroll: 2,
						nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
						prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>'
					});
				}
				if ($(window).width() < 480 && recommendationCarouselItem1.length > 1) {
					recommendationCarousel1.not('.slick-initialized').slick({
						slidesPerRow: 2,
						rows: 2,
						dots: true,
						infinite: false,
						speed: 300,
						nextArrow: '<div class="slick-btn-wrapper"><button class="slick-next"><span class="next"></span></button></div>',
						prevArrow: '<div class="slick-btn-wrapper"><button class="slick-prev"><span class="prev"></span></button></div>'
					});
				}
			}

			if($('.category-recommendations-block .slick-initialized')){
				$('.category-recommendations-block .item-1, .category-recommendations-block .item-2, .category-recommendations-block .item-3').css('max-width', '100%');
			}
		}
	}
}

function initPLPSlider() {
	// for each loop to initialize slider
	var isDesktop = window.matchMedia("(min-width: 1025px)").matches;
	if(isDesktop) {
		$('.recommendation-redesign .carousel-recommendations .product-slick-track').each(function () {
			var slider = $(this);
			if(!$(this).hasClass("slick-initialized")) {
				$(slider).slick({
					initialSlide: 0,
					autoplay: false,
					dots: false,
					arrows: true,
					infinite: false,
					speed: 150,
					fade: true,
					cssEase: 'linear',
					slidesToShow: 1,
					responsive: [
						{
							breakpoint: 1024,
							settings: {
							arrows: false,
							dots: true,
							}
						}
					]
				});
			}// Initialize the Slick slider
			
			var timer;
			var manualNavigation = false;

			$(slider).on({
				/**
				 * If the user has not manually navigated, shows the second slide after a delay.
				 *
				 */
				mouseenter: function () {
					clearTimeout(timer);

					// If the user has not manually navigated, show the second slide
					if (manualNavigation !== true && isDesktop) {
						var currentIndex = slider.slick('slickCurrentSlide');
						if (currentIndex !== undefined) {
							timer = setTimeout(function () {
								if (currentIndex === 0) { // If the current slide is the first slide
									slider.slick('slickGoTo', 1); // Show the second slide
								}
							}, 100);
						}
					} 
				},
				mouseleave: function () {
					clearTimeout(timer);

					// If the user has not manually navigated, revert to the first slide
					if (manualNavigation !== true && isDesktop) {
						var currentIndex = slider.slick('slickCurrentSlide');
						if (currentIndex !== undefined) {
							timer = setTimeout(function () {
								if (currentIndex !== 0) { // If the current slide is not the first slide
									slider.slick('slickGoTo', 0); // Show the first slide
								}
							}, 100);
						}
					}
				}
			});
	
			/**
			 * Sets a flag to indicate that the user has manually navigated the slider.
			 * This is triggered when the user clicks on a slider arrow.
			*/
			$(slider).find('.slick-arrow').on('click', function(e) {
				if ($(this).length) { // Check if the element exists
					manualNavigation = true; // Set manual navigation flag
				}
			});
		});
	}
}

// Recommendation Redesign Mobile carousel initialization 
function recommendationRedesign() {

	if($('.recommendation-redesign').length && $(window).width() < 991) {
		var recommendationSelector = $('.recommendation-redesign .carousel-recommendations');

		$('.recommendation-redesign').closest('.recommendation-block').addClass('re-minheight');
		$('.recommendation-redesign').closest('.container').addClass('rec-no-padding');

		// OverlayScrollbars initialization with an element
		recommendationSelector.each(function (index, ele) {
			var osInstance = OverlayScrollbars($(ele), {});
		});

		setTimeout(() => {
			util.equalHeight($('.recommendation-redesign .product-tile'));
			util.equalHeight($('.recommendation-redesign .recommendation-slide'));
			util.ellipsisOnLongText($('.product-tile .product-brand-name-block .product-name'));
		}, 3000);

		if($(".plp-cross-sell").length) {
			const $element = $(".plp-cross-sell");
			const $tileLength = $element.find(".os-content .recommendation-item").length;
			if($tileLength == 2) {
				$element.find(".os-content").addClass("left-os-content");
			} else {
				$element.find(".os-content").removeClass("left-os-content");
			}
		}
	} else {
		var recommendationSelector = $('.recommendation-redesign .carousel-recommendations');
		recommendationSelector.each(function (index, ele) {
			var osInstance = OverlayScrollbars($(ele), {}).destroy(); // Disable for desktop screen
		});
	}
}

var recommendationsCarousel = {
    init: function() {
        recommendationCarousel();
		recommendationRedesign();
		crossSellTabs.init();
		util.ellipsisOnLongText($('.product-tile .product-brand-name-block .product-name'));
		var elementSelector = $('.carousel-recommendations .recommendation-slide');
		elementSelector.each(function (index, ele) {
			 $(ele).find('.attribute.single-size .basic-price').length > 0 && $(ele).find('.product-variants-wrapper').addClass('shift-up');
		});
		
		$(window).on('resize orientationchange', function () {
				recommendationCarousel();
				recommendationRedesign();
				if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
					initPLPSlider();
				}
		});
		if(!window.SitePreferences.ENABLE_SINGLE_TILE_IMAGE) {
			initPLPSlider();
		}
	}
}

export default recommendationsCarousel;
